module.exports = __webpack_public_path__ + "static/media/collage_04.d4877872.png";